import type { PlaybookTeamScoreCriterion } from "@repo/app-types/agents/getPlaybookTeamScoresTool";

type GradingValueType = PlaybookTeamScoreCriterion["grading_value_type"];

const percentFormatter = new Intl.NumberFormat(undefined, {
  style: "percent",
  maximumFractionDigits: 0,
});

/**
 * Formats a criterion's team-level score in its own units: a 0-1 pass rate for
 * yes/no criteria (shown as a percentage) or a 1-5 average for score criteria.
 */
export function formatCriterionScore(
  score: number | null,
  gradingValueType: GradingValueType,
): string {
  if (score === null) {
    return "—";
  }
  return gradingValueType === "yes_no"
    ? percentFormatter.format(score)
    : score.toFixed(1);
}

/**
 * Formats the magnitude of a score change in the criterion's own units
 * (pass-rate points for yes/no, 1-5 points for score criteria). The direction
 * is conveyed separately (e.g. by an arrow), so this returns the absolute value.
 */
export function formatCriterionScoreDelta(
  change: number,
  gradingValueType: GradingValueType,
): string {
  const magnitude = Math.abs(change);
  return gradingValueType === "yes_no"
    ? percentFormatter.format(magnitude)
    : magnitude.toFixed(1);
}

/** Formats a 0-1 rate (e.g. overall playbook adherence, win rate) as a percentage. */
export function formatRate(rate: number | null): string {
  return rate === null ? "—" : percentFormatter.format(rate);
}
